import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { Order, useGuia } from "../../../Hooks/guia";
import { FormataMoeda } from "../../../Utils/formataMoeda";
import { cpfMask } from "../../../Services/cpfMask";
import { ChevronDown, ChevronUp } from "react-feather";
import theme from "../../../Styles/theme";
import { CotaninerArrow } from "./styled";
import { app_full_url } from "../../../Utils/baseUrl";

interface Props {
  imprimir?: boolean;
  tipo?: "urbano" | "rural" | "todos";
}

export function Tabela({ imprimir, tipo = "todos" }: Props) {
  const {
    guias,
    loading,
    ordenacao,
    handleOrdenacao,
    baseTotal,
    itbiTotal,
    somenteResumo,
  } = useGuia();

  const rows = guias.filter((g) => {
    if (tipo === "todos") return true;

    const ehUrbano = g.CHAVE.toString().substring(0, 1) === "1";

    if (tipo === "urbano") return ehUrbano;
    if (tipo === "rural") return !ehUrbano;

    return true;
  });

  function defineColor(parametro: Order) {
    if (
      ordenacao.ORDER === parametro.ORDER &&
      ordenacao.PARAMETRO === parametro.PARAMETRO
    ) {
      return theme.colors.primary;
    }

    return theme.colors.darkGrey;
  }

  function getStatusStyle(status: string) {
    if (status === "P") {
      return {
        label: "PAGO",
        bg: "#e6f4ea",
        color: "#1e7e34",
      };
    }

    if (status === "C") {
      return {
        label: "CANCELADO",
        bg: "#fdecea",
        color: "#b02a37",
      };
    }

    if (status === "S") {
      return {
        label: "COMPUTADO",
        bg: "#e7f0ff",
        color: "#1d4ed8",
      };
    }

    return {
      label: "PENDENTE",
      bg: "#f3f4f6",
      color: "#374151",
    };
  }

  return (
    <TableContainer component={Paper} elevation={0}>
      {loading ? (
        ""
      ) : (
        <Table sx={{ minWidth: 650 }} aria-label="simple table" size="small">
          <TableHead>
            <TableRow>
              <TableCell
                align="center"
                style={{ fontSize: imprimir ? "10px" : "14px" }}
              >
                {imprimir ? (
                  "PERÍODO"
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      width: "100%",
                      flexWrap: "nowrap",
                    }}
                    onClick={() => handleOrdenacao("PERIODO")}
                  >
                    <CotaninerArrow>
                      <ChevronUp
                        size={"18PX"}
                        style={{
                          color: defineColor({
                            ORDER: -1,
                            PARAMETRO: "PERIODO",
                          }),
                        }}
                      />
                      <ChevronDown
                        size={"18PX"}
                        style={{
                          color: defineColor({
                            ORDER: 1,
                            PARAMETRO: "PERIODO",
                          }),
                        }}
                      />
                    </CotaninerArrow>
                    PERÍODO
                  </div>
                )}
              </TableCell>

              <TableCell
                align="center"
                style={{ fontSize: imprimir ? "10px" : "14px" }}
              >
                {imprimir ? (
                  "STATUS"
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      width: "100%",
                      flexWrap: "nowrap",
                    }}
                    onClick={() => handleOrdenacao("STATUS")}
                  >
                    <CotaninerArrow>
                      <ChevronUp
                        size={"18PX"}
                        style={{
                          color: defineColor({
                            ORDER: -1,
                            PARAMETRO: "STATUS",
                          }),
                        }}
                      />
                      <ChevronDown
                        size={"18PX"}
                        style={{
                          color: defineColor({
                            ORDER: 1,
                            PARAMETRO: "STATUS",
                          }),
                        }}
                      />
                    </CotaninerArrow>
                    STATUS
                  </div>
                )}
              </TableCell>

              <TableCell
                align="center"
                style={{ fontSize: imprimir ? "10px" : "14px" }}
              >
                {imprimir ? (
                  "PROCESSO"
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      width: "100%",
                      flexWrap: "nowrap",
                    }}
                    onClick={() => handleOrdenacao("PROCESSO")}
                  >
                    <CotaninerArrow>
                      <ChevronUp
                        size={"18PX"}
                        style={{
                          color: defineColor({
                            ORDER: -1,
                            PARAMETRO: "PROCESSO",
                          }),
                        }}
                      />
                      <ChevronDown
                        size={"18PX"}
                        style={{
                          color: defineColor({
                            ORDER: 1,
                            PARAMETRO: "PROCESSO",
                          }),
                        }}
                      />
                    </CotaninerArrow>
                    PROCESSO
                  </div>
                )}
              </TableCell>

              <TableCell
                align="center"
                style={{ fontSize: imprimir ? "10px" : "14px" }}
              >
                {imprimir ? (
                  "BASE"
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      width: "100%",
                      flexWrap: "nowrap",
                    }}
                    onClick={() => handleOrdenacao("BASE")}
                  >
                    <CotaninerArrow>
                      <ChevronUp
                        size={"18PX"}
                        style={{
                          color: defineColor({
                            ORDER: -1,
                            PARAMETRO: "BASE",
                          }),
                        }}
                      />
                      <ChevronDown
                        size={"18PX"}
                        style={{
                          color: defineColor({
                            ORDER: 1,
                            PARAMETRO: "BASE",
                          }),
                        }}
                      />
                    </CotaninerArrow>
                    BASE
                  </div>
                )}
              </TableCell>

              <TableCell
                align="center"
                style={{ fontSize: imprimir ? "10px" : "14px" }}
              >
                {imprimir ? (
                  "ITBI"
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      width: "100%",
                      flexWrap: "nowrap",
                    }}
                    onClick={() => handleOrdenacao("ISSQN")}
                  >
                    <CotaninerArrow>
                      <ChevronUp
                        size={"18PX"}
                        style={{
                          color: defineColor({
                            ORDER: -1,
                            PARAMETRO: "ISSQN",
                          }),
                        }}
                      />
                      <ChevronDown
                        size={"18PX"}
                        style={{
                          color: defineColor({
                            ORDER: 1,
                            PARAMETRO: "ISSQN",
                          }),
                        }}
                      />
                    </CotaninerArrow>
                    ITBI
                  </div>
                )}
              </TableCell>

              <TableCell
                align="center"
                style={{ fontSize: imprimir ? "10px" : "14px" }}
              >
                {imprimir ? (
                  "INFORMANTE"
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      width: "100%",
                      flexWrap: "nowrap",
                    }}
                    onClick={() => handleOrdenacao("INFORMANTE")}
                  >
                    <CotaninerArrow>
                      <ChevronUp
                        size={"18PX"}
                        style={{
                          color: defineColor({
                            ORDER: -1,
                            PARAMETRO: "INFORMANTE",
                          }),
                        }}
                      />
                      <ChevronDown
                        size={"18PX"}
                        style={{
                          color: defineColor({
                            ORDER: 1,
                            PARAMETRO: "INFORMANTE",
                          }),
                        }}
                      />
                    </CotaninerArrow>
                    INFORMANTE
                  </div>
                )}
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows &&
              rows.map((row) => {
                const status = getStatusStyle(row.COMPUTADA);

                return !somenteResumo ? (
                  <TableRow
                    style={{ cursor: "pointer" }}
                    key={row.ID}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                      "&:hover": {
                        backgroundColor: "#f9fafb",
                      },
                    }}
                    onClick={() => {
                      window.open(
                        `${app_full_url}/imovel${
                          row.CHAVE.toString().substring(0, 1) === "1"
                            ? ""
                            : "-rural"
                        }/${row.CHAVE.toString().substring(
                          1,
                          row.CHAVE.toString().length
                        )}`,
                        "_blank"
                      );
                    }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      align="center"
                      style={{ fontSize: imprimir ? "10px" : "14px", fontWeight:"bold" }}
                    >
                      {row.PERIODO.padStart(7, "0")}
                    </TableCell>

                    <TableCell
                      component="th"
                      scope="row"
                      align="center"
                      style={{ fontSize: imprimir ? "10px" : "14px" }}
                    >
                      <Box
                        sx={{
                          backgroundColor: status.bg,
                          color: status.color,
                          px: 1.2,
                          py: 0.4,
                          borderRadius: 1.5,
                          fontSize: "0.75rem",
                          fontWeight: 700,
                          display: "inline-block",
                          minWidth: 100,
                          textAlign: "center",
                          border: "1px solid",
                          borderColor: `${status.color}33`,
                        }}
                      >
                        {status.label}
                      </Box>
                    </TableCell>

                    <TableCell
                      component="th"
                      scope="row"
                      align="center"
                      style={{ fontSize: imprimir ? "10px" : "14px" , fontWeight:"bold"}}
                    >
                      {row.PROCESSO? `${row.PROCESSO.toString().padStart(4, "0")}/
                      ${new Date(row.DATA_INFORMACAO).getFullYear()}`:""}
                    </TableCell>

                    <TableCell
                      component="th"
                      scope="row"
                      align="center"
                      style={{ fontSize: imprimir ? "10px" : "14px", fontWeight:"bold" }}
                    >
                      {FormataMoeda(row.BASE)}
                    </TableCell>

                    <TableCell
                      component="th"
                      scope="row"
                      align="center"
                      style={{ fontSize: imprimir ? "10px" : "14px", fontWeight:"bold" }}
                    >
                      {FormataMoeda(row.ISSQN)}
                    </TableCell>

                    <TableCell
                      component="th"
                      scope="row"
                      align="center"
                      style={{ fontSize: imprimir ? "10px" : "14px" }}
                    >
                      {cpfMask(row.CPFINFORMANTE)}
                    </TableCell>
                  </TableRow>
                ) : (
                  <React.Fragment key={row.ID}></React.Fragment>
                );
              })}

            <TableRow
              key={0}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                backgroundColor: "#f8fafc",
              }}
            >
              <TableCell
                component="th"
                scope="row"
                align="center"
                sx={{ fontWeight: 800 }}
              >
                TOTAL
              </TableCell>

              <TableCell component="th" scope="row" align="center"></TableCell>
              <TableCell component="th" scope="row" align="center"></TableCell>

              <TableCell
                component="th"
                scope="row"
                align="center"
                sx={{ fontWeight: 700 }}
              >
                {FormataMoeda(baseTotal)}
              </TableCell>

              <TableCell
                component="th"
                scope="row"
                align="center"
                sx={{ fontWeight: 700 }}
              >
                {FormataMoeda(itbiTotal)}
              </TableCell>

              <TableCell component="th" scope="row" align="center"></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      )}
    </TableContainer>
  );
}